export default __webpack_public_path__ + "static/the_universe-7fdf1ade28d4752b6f2a6936be8440d4.png";